<template>
	<div class="page-properties" ref="page_properties">
		<div class="agent-activity-wrap">
			<div class="agent-activity-wrap-title">
				<div class="agent-activity-wrap-title-box">
					<h1 class="section-title section-title--agent-activity">Agent Activity Log</h1>
				</div>
			</div>
			<PartInputSearch class="agent-activity__search" :data="DataSearch"/>
			<div class="table-wrap">
				<BlockTable
					:data="DataAgentsActivity"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import BlockTable from '@/components/blocks/BlockTable';
import PartInputSearch from '@/components/parts/PartInputSearch';

export default {
	data: () => {
		return {
			DataSearch: {
				type: 'text',
				inputId: 'agent-activity-input',
				placeholder: 'Search by property owner or address...',
				label: '',
				labelId: 'agent-activity-label',
				searchClass: ''
			},
			DataAgentsActivity: {
				stickyHeader: true,
				noLocalSorting: true,
				noCollapse: false,
				fields: [
					{ key: 'title', label: 'Property', sortable: true, stickyColumn: true, variant: 'property property-lg thead-lg' },
					{ key: 'Owner', label: 'Owner', sortable: true, stickyColumn: true, variant: 'owner' },
					{ key: 'sent_on', label: 'Sent On', sortable: true, stickyColumn: true, variant: 'sent-on' },
					{ key: 'doc_type', label: 'Type', sortable: true, stickyColumn: true, variant: 'doc-type' },
					{ key: 'additional_info', label: 'Additional Info', sortable: true, stickyColumn: true, variant: 'additional-info' },
					{ key: 'lead_name', label: 'Lead Name', sortable: true, stickyColumn: true, variant: 'lead-name' },
					{ key: 'lead_email', label: 'Lead Email', sortable: true, stickyColumn: true, variant: 'lead-email' }
				],
				items: []
			}
		};
	},
	components: {
		BlockTable,
		PartInputSearch
	},
	methods: {
	}
};
</script>
<style lang="scss" scoped>
.agent-activity-wrap-title {
	display: flex;
	align-items: center;
	margin-bottom: 29px;
	position: relative;
	justify-content: space-between;

	@include mq(1300px) {
		flex-wrap: wrap;
	}

	@include mq(560px) {
		flex-direction: column;
		justify-content: center;
		margin-bottom: 0;
	}
}

.verified-property-checkbox {
    max-width: 350px;
	width: 100%;
    margin-left: 15px;
	z-index: 100;

	&--agent {
		z-index: 1000;
	}

	@include mq(1440px) {
		max-width: 280px;
	}

	@include mq(850px) {
		margin: 0 auto;
		max-width: 250px;
	}
}

.agent-activity-wrap-title-box {
	display: flex;
	align-items: center;
	position: relative;
	margin-right: auto;

	@include mq(850px) {
		justify-content: center;
		width: 100%;
		margin-right: 0;
		margin-bottom: 15px;
	}
}

.page-properties {
	max-width: 100%;
	width: 100%;
	padding: 43px 35px 43px 0;

	@include mq(1500px) {
		padding: 43px 15px;
	}

	@include mq(1200px) {
		max-width: 100%;
	}

	@include mq($xl) {
		padding: 20px 0;
	}
}

.agent-activity-table {
    max-width: 100%;
	margin: 0;
}

.section-title--agent-activity {
	margin: 0 24px 0 2px;
	white-space: nowrap;
}

.dashboard-properties-wrap__header {
	display: flex;
	margin: 0;
	width: 100%;
}

.dashboard-properties-wrap__header-link {
	font-family: $font-main;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: $shuttle-gray;
	display: flex;
    justify-content: center;
    align-items: center;
    padding: 13px;
	transition: $dur $ease;
	text-decoration: none;
	max-width: 33.3%;
	flex: 0 0 33.3%;
	width: 100%;
	position: relative;
	background-color: $white-lilac;

	@include mq($md) {
		font-size: 14px;
	}

	@include mq(670px) {
		padding: 10px;
		flex-direction: column;
	}

	&::after {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		background-color: $selago;
		width: 1px;
		height: 100%;
		opacity: 0.4;
		transition: $dur $ease;
	}

	&:first-of-type {
		border-top-left-radius: 14px;
	}

	&:last-of-type {
		border-top-right-radius: 14px;
		&::after {
			display: none;
		}
	}

	&.is-active-link {
		background-color: $link-water;
		color: $dodger-blue;
	}

	@include hover {
		background-color: $link-water;
		color: $dodger-blue;
	}
}

.dashboard-properties-wrap__icon {
	display: inline-block;
    padding-right: 7px;
	font-size: 14px;
	height: 20px;

	@include mq(670px) {
		display: none;
	}

	svg {
		display: block;
		height: 14px;
	}
}

.dashboard-properties-wrap__icon--list {
	font-size: 11px;
	height: 20px;
}

.dashboard-properties-wrap__header-inner {
	@include mq(460px) {
		flex-direction: column;
		display: flex;
	}
}

.notification-wrap-middle {
	position: relative;
	transform: none;
	left: auto;
	top: auto;
	width: 100%;
	align-items: center;
	justify-content: center;
	display: flex;

	@include mq(1300px) {
		order: 3;
	}
}
</style>
